import { Box } from '@mafc/trolly';
import React from 'react';
import COLORS from 'theme/colors';

const CardDivider = (props: any) => {
  return (
    <Box
      as="span"
      sx={{ backgroundColor: COLORS.WILD_SAND, display: 'block', height: '1px', marginBottom: 3 }}
      {...props}
    />
  );
};

export default CardDivider;
